const folder = document.env.API_HOST + '/images'
export const getImage = (name) => `${folder}/${name}`

export const convertToBase64 = (selectedFile, cb) => {
  if (selectedFile.length > 0) {
    let fileToLoad = selectedFile[0]
    let fileReader = new FileReader()
    let base64
    fileReader.onload = function(fileLoadedEvent) {
      base64 = fileLoadedEvent.target.result
      cb(base64)
    }
    fileReader.readAsDataURL(fileToLoad)
  }
}

export const customToolbar = () => [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }],
  [
    { align: '' },
    { align: 'center' },
    { align: 'right' },
    { align: 'justify' }
  ],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['image', 'video', 'link'],
  ['clean']
]

export const customCKEditorConfig = () => ({
  language: 'pt-br',
  toolbar: [ 'heading', '|', 'Essentials', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
  image: {
    styles: [
          'alignLeft', 'alignCenter', 'alignRight'
      ],
    // Configure the available image resize options.
    resizeOptions: [
        {
            name: 'imageResize:original',
            label: 'Original',
            value: null
        },
        {
            name: 'imageResize:50',
            label: '50%',
            value: '50'
        },
        {
            name: 'imageResize:75',
            label: '75%',
            value: '75'
        }
    ],
    // You need to configure the image toolbar, too, so it shows the new style
    // buttons as well as the resize buttons.
    toolbar: [
        'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
        '|',
        'imageResize',
        '|',
        'imageTextAlternative'
    ]
  }
})



// WEBPACK FOOTER //
// ./src/helpers/utils.js